import TickerCell from './TickerCell';

export default TickerCell;
